import { render } from "./PaquetesPreciosView.vue?vue&type=template&id=725ff0ac"
import script from "./PaquetesPreciosView.vue?vue&type=script&lang=js"
export * from "./PaquetesPreciosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__